import { Controller } from '@hotwired/stimulus'

import Splide from '@splidejs/splide'

export default class extends Controller {
  connect() {
    console.log('splide controller connected')
    new Splide(this.element, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      gap: 24,
      pagination: false,
      arrows: false,
      breakpoints: {
        1536: {
          perPage: 2
        },
        1023: {
          padding: {
            right: 40,
            left: 50
          },
          perPage: 1,
          pagination: true
        },
        480: {
          padding: {
            left: 40,
            right: 30
          },
          perPage: 1,
          pagination: true
        }
      }
    }).mount()
  }
}
